<script setup lang="ts">
const props = defineProps<{
  modelValue?: boolean | string
  label?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'update:model-value', value: boolean): void
}>()

function onChange(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
  emit('update:model-value', checked)
}
</script>

<template>
  <label class="auth-check">
    <input
      type="checkbox"
      :checked="modelValue === true || modelValue === 'on'"
      @change="onChange"
    />
    <span class="auth-check__label">{{ label }}</span>
  </label>
</template>
